import { PublicClientApplication } from '@azure/msal-browser';
import { notification } from 'antd';
import { useEffect, useState } from 'react';
import { redirectUri } from './app-configs';

import getCOPScookie from './cookies';
import { checkEnv } from './helpers';

/**
 * This hook will relogin the user with other scopes.
 * These scopes cannot be part of already existing resources to which the user already has access
 * We handle everything outside the cops authenticator to avoid interfering with the user's
 *   current local storage/session, access to the current resource, and token.
 * @param {*} userConfig The config will provide all the config that is needed to do a request
 * @returns
 */
const useADLogin = ({ scopes, userRedirectUri = null, prompt }) => {
  const [token, setToken] = useState(null);
  const [loginSucces, setLoginSucces] = useState(null);

  const config = {
    auth: {
      clientId: getCOPScookie('ClientId') || AUTH_CLIENTID,
      authority: `https://login.microsoftonline.com/${getCOPScookie('Tenant') || AUTH_TENANT}`,
      redirectUri: userRedirectUri || redirectUri[checkEnv()],
    },
  };

  const pca = new PublicClientApplication(config);

  async function initializeMsal() {
    await pca.initialize();
  }

  async function acquireToken() {
    if (!token && !loginSucces) {
      const loginRequest = {
        scopes: scopes || [],
        prompt: prompt || 'none', // Prompt the user to select an account
      };
      try {
        let accounts = pca.getAllAccounts();
        if (accounts.length === 0) {
          // Perform interactive login
          await pca.loginPopup(loginRequest);
          accounts = pca.getAllAccounts();
        }
        // Set the active account
        pca.setActiveAccount(accounts[0]);
        // Acquire the token after login
        const response = await pca.acquireTokenSilent(loginRequest);
        const { accessToken } = response;
        // Use the obtained access token for your API calls
        setToken(accessToken);
        setLoginSucces(true);
      } catch (error) {
        if (error?.errorCode === 'interaction_required') {
          setLoginSucces(false);
        } else {
          notification.error({
            message: error?.errorMessage,
            placement: 'top',
          });
        }
      }
    }
  }

  useEffect(() => {
    initializeMsal().then(() => {
      acquireToken();
    });
  }, [scopes, userRedirectUri, prompt]);

  return {
    token,
    loginSucces,
  };
};

export default useADLogin;
